"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderRefundLineItemsData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
// The data payload attached to an order refund line items push notification.
exports.OrderRefundLineItemsData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("orderRefundLineItems"),
    // The human-readable amount by which the order was refunded.
    amount: runtypes_1.String,
    // The uuid of the customer who placed the order that was refunded.
    customer: UUID_1.UUID,
    // Order refund reason.
    description: runtypes_1.String,
    // The uuid of the order which was adjusted.
    order: UUID_1.UUID,
    // The site on which the order was placed.
    site: UUID_1.UUID,
    // @deprecated but retained for backwards compatibility.
    portal: UUID_1.UUID,
}));
//# sourceMappingURL=OrderRefundLineItemsData.js.map